import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ConfigService } from '../@vex/config/config.service';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { NavigationService } from '../@vex/services/navigation.service';
import icLayers from '@iconify/icons-ic/twotone-layers';
import { LayoutService } from '../@vex/services/layout.service';
import { ActivatedRoute } from '@angular/router';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { SplashScreenService } from '../@vex/services/splash-screen.service';
import { ConfigName } from '../@vex/config/config-name.model';
import { ColorSchemeName } from '../@vex/config/colorSchemeName';
import { SharedService } from './shared/shared.service';
import { AuthenticationService } from './authservices/authentication.service';
import { environment } from 'src/environments/environment';
import moment from 'moment';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  auth_key:any='c538df56fa723943cbe2c3222cb30777';
  constructor(private configService: ConfigService,
              private renderer: Renderer2,
              private platform: Platform,
              @Inject(DOCUMENT) private document: Document,
              @Inject(LOCALE_ID) private localeId: string,
              private layoutService: LayoutService,
              private route: ActivatedRoute,
              private navigationService: NavigationService,
              private splashScreenService: SplashScreenService,
              private shared_service:SharedService,
              private auth_service:AuthenticationService,
              ) {
    Settings.defaultLocale = this.localeId;
    

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.shared_service.setAuthKey(this.auth_key);

    /**
     * Customize the template to your needs with the ConfigService
     * Example:
     *  this.configService.updateConfig({
     *    sidenav: {
     *      title: 'Custom App',
     *      imageUrl: '//placehold.it/100x100',
     *      showCollapsePin: false
     *    },
     *    footer: {
     *      visible: false
     *    }
     *  });
     */

    /**
     * Config Related Subscriptions
     * You can remove this if you don't need the functionality of being able to enable specific configs with queryParams
     * Example: example.com/?layout=apollo&style=default
     */
    this.route.queryParamMap.subscribe(queryParamMap => {
      if (queryParamMap.has('layout')) {
        this.configService.setConfig(queryParamMap.get('layout') as ConfigName);
      }

      if (queryParamMap.has('style')) {
        this.configService.updateConfig({
          style: {
            colorScheme: queryParamMap.get('style') as ColorSchemeName
          }
        });
      }

      if (queryParamMap.has('rtl')) {
        this.configService.updateConfig({
          direction: coerceBooleanProperty(queryParamMap.get('rtl')) ? 'rtl' : 'ltr'
        });
      }
    });


    if(this.auth_service.isTokenValid()){
      this.loadStartUp()
    }


    

  }

  loadStartUp(){

    var data = {
      device_type:"Web",
      device_os:"Web",
      device_unique_id:"",
      device_other_details:"",
      device_token:"",
      app_name:environment.app_name,
      api_at:moment().unix(),
      // api_at_tz:moment.tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('Z'),
      api_datetime:moment().format('YYYY-MM-DD HH:mm:ss'),
      start_up:this.auth_service.isLoggedIn()['token_data']
      
    }
    
    let enc_data = this.shared_service.encrypt(this.auth_key,JSON.stringify(data))


    var formData = new FormData();
      
    formData.append('data', enc_data);
    // formData.append('data', this.form.value);
  
    this.auth_service.startUp(formData).subscribe(
      (serverResponse) => {


        this.auth_service.removeTokenSession();

        this.auth_service.getToken(serverResponse.payload);

        let payload_data = this.shared_service.decrypt(this.auth_key,serverResponse.payload);

        this.shared_service.setUserData(payload_data.user);


      })
  }
}
